import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { LocalStorageCodes } from '../../../core/codes';
//import { Observable } from 'rxjs/Observable';
//import { AppSettings } from '../../../config/app-settings';
@Injectable()
export class LocalRecipeBoxData {
    constructor(private storage: Storage,
    ) {

    }
    public set(userRecipes, userId): Promise<any> {
        return this.search(userId).then(localUserRecipes => {
            let strgRef = LocalStorageCodes.USER_RECIPES + '/' + userId;

            if (!localUserRecipes) {
                localUserRecipes = {};
            }
            localUserRecipes = userRecipes;

            console.log(localUserRecipes);
            return this.storage.set(strgRef, JSON.stringify(localUserRecipes)).then(result => {
                console.log(result);

            });
        });

    }
    public search(uid?) {
        let strgRef = LocalStorageCodes.USER_RECIPES + '/' + uid;
        return this.storage.get(strgRef).then(function (value) {
            if (value) {
                var result = JSON.parse(value);
            }
            return result ? result : null;
        });

    }

    public add(userId,recipeId, userRecipe): Promise<any> {
        return this.search(userId).then(localUserRecipes => {
            let strgRef = LocalStorageCodes.USER_RECIPES + '/' + userId;
            if (!localUserRecipes || localUserRecipes.constructor === Array) {
                localUserRecipes = {};
            }
            localUserRecipes[recipeId] = userRecipe;
            console.log(localUserRecipes);
            return this.storage.set(strgRef, JSON.stringify(localUserRecipes));
        });
    }
    public remove(userId,recipeId): Promise<any> {
        return this.search(userId).then(localUserRecipes => {
            let strgRef = LocalStorageCodes.USER_RECIPES + '/' + userId;
            console.log(strgRef);
            console.log(userId);
            if (!localUserRecipes || localUserRecipes.constructor === Array) {
                localUserRecipes = {};
            }
            delete localUserRecipes[recipeId];
            console.log(localUserRecipes);
            return this.storage.set(strgRef, JSON.stringify(localUserRecipes));
        });
    };
    // public updateTimeStampModified(ref,timeStamp) {
    //     let self = this;
    //     return this.storage.get(ref).then(function (value) {
    //         if (!value) {
    //             return;
    //         }
    //         var result = JSON.parse(value);
    //         console.log(ref);
    //         result['timestampModified'] = timeStamp;
    //         console.log(JSON.parse(JSON.stringify(result)));
    //         return self.storage.set(ref, JSON.stringify(result));
    //     });
    // }
    
}


// WEBPACK FOOTER //
// ./src/modules/recipes/providers/local-recipe-box-data.ts